/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgListConversation = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <style>{'.ico-list-conversation_svg__st0{fill:currentcolor}'}</style>
    <path
      className="ico-list-conversation_svg__st0"
      d="M12 16c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3zm0 4c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm-7-9h12v2H5z"
    />
    <path
      className="ico-list-conversation_svg__st0"
      d="M1 2v20h3.5l3.3-4.4-1.6-1.2L3.5 20H3V4h16v10h2V2z"
    />
    <path className="ico-list-conversation_svg__st0" d="M5 7h12v2H5zm12 11h4v2h-4z" />
  </Icon>
);
export { SvgListConversation as ListConversation };
